import React, { Component } from "react";
import { Link } from "react-router-dom";
import Table from "../utils/table";

import ContentHeader from "./ContentHeader";
class AdminList extends Component {
  render() {
    let {
      admins,
      loading,
      handleEvent
    } = this.props;

    let tableFields = [
      { name: "last_name", header: "Last Name" },
      { name: "first_name", header: "First Name" },
      { name: "email", header: "Email" },
      { name: "edit", type: "action", header: "", action: "editAdmin" },
      {
        name: "changeAdminPassword",
        type: "action",
        header: "",
        action: "changeAdminPassword"
      }
    ];

    let clientLink = (
      <Link to="/admins/new" className="btn btn-primary">
        {" "}New Administrator{" "}
      </Link>
    );

    let content;
    if (loading) {
      content = (
        <div className="zero-items">
          <p> Fetching administrators, please wait ... </p>
        </div>
      );
    } else {
      content = (
        <div className="zero-items">
          {clientLink}
        </div>
      );
    }

    let columnWrappers = {
      changeAdminPassword(f) {
        return <span> <i className="fa fa-lock"> </i> </span>;
      },
      edit(f) {
        return <span> <i className="fa fa-pencil"> </i> </span>;
      }
    };

    let newAdminLink;

    if (admins.length !== 0) {
      content = (
        <div>
          <Table
            tableData={admins}
            tableFields={tableFields}
            handleEvent={handleEvent}
            columnWrappers={columnWrappers}
          />
          <div />
        </div>
      );

      newAdminLink = clientLink;
    }
    return (
      <div>
        <ContentHeader title="Administrators">
          <span className="pull-right">
            {newAdminLink}
          </span>
        </ContentHeader>
        {content}
      </div>
    );
  }
}

export default AdminList;



// WEBPACK FOOTER //
// ./src/components/AdminList.js